import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { ISession } from '../interfaces/session';
import * as Sentry from "@sentry/angular";

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private apiBaseUrl = `${environment.apiDomain}/auto-insurance`;
  constructor(private http: HttpClient, private cookieService: CookieService) { }

  generateSession(fullURL: string, referrerURL: string): Observable<ISession> {
    const body = {};
    let url = `${this.apiBaseUrl}/generate-session?url=${fullURL}`;

    if (referrerURL) {
      url += `&referrerURL=${referrerURL}`;
    }
    return this.http.post<ISession>(url, body);
  }

  saveSessionToLocalStorage(session: ISession): void {
    try{
    if (typeof window !== 'undefined' && window.localStorage) {
      let setSession = false;
      Object.keys(session).forEach((key) => {
        if (key === 'session-uuid') {
          setSession = true;
          if(session[key] !== null && session[key] !== undefined && session[key] !== 'null'){   
            localStorage.setItem(key, session[key]);                  
            Sentry.setUser({ id: session[key] });
          }else{
            new Error('session-uuid not set inside local storage since session is null' + JSON.stringify(session));
          }
          
        } else {
          localStorage.setItem(key, JSON.stringify(session[key]));
        }        
      });     
    } else {
      console.info('window is undefined not saving session');
      throw new Error('session-uuid not set inside local storage since windows is undefined' + JSON.stringify(session));
    }
  }catch(e){
    console.log('Error on saveSessionToLocalStorage ' + e);
    throw new Error('Error on saveSessionToLocalStorage ' + e);
  }
  }

  getSessionId(): string {  
    const sessionId = localStorage.getItem('session-uuid') as string;
    if(sessionId == null || sessionId == undefined || sessionId === 'null'){
      let cookieSession = this.cookieService.get('session-uuid');               
      throw new Error('session-uuid not found ' + sessionId + ' but in cookie found ' + cookieSession);
    }
    return sessionId;    
  }

  updateSession(uuid: any, fbp: any, fbc: any, jornayaLeadId: any, cookies: any, referrer: any): Observable<any> {
    let leadId = uuid ? `uuid=${uuid}` : '';
    let fbpCookie = fbp ? `&fbp=${fbp}` : '';
    let fbcCookie = fbc ? `&fbc=${fbc}` : '';
    let jornayaLeadIdCookie = jornayaLeadId ? `&jornayaLeadId=${jornayaLeadId}` : '';
    let referrerURL = fbc ? `&referrerURL=${referrer}` : '';

    const url = `${this.apiBaseUrl}/update-session?${leadId}${fbpCookie}${fbcCookie}${jornayaLeadIdCookie}${referrerURL}`;

    return this.http.post(url, cookies);
  }
}
